import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  getAssignableWorkspaceRoleOptions,
  getWorkspaceRoleLabel,
  isWorkspaceRoleLocked,
  normalizeEditableRole,
} from "@/lib/userRoles";

/**
 * Selector de rol o badge solo lectura (platform_designer, buyer_admin, propietario).
 */
export default function UserRoleField({
  targetUser,
  value,
  onChange,
  showReseller = false,
  includeConsulta = true,
  disabled = false,
  isBuyerTenantAdmin = false,
  label = "Rol del usuario",
  id = "user-role-field",
}) {
  const locked = disabled || isWorkspaceRoleLocked(targetUser) || isBuyerTenantAdmin;

  if (locked && targetUser) {
    return (
      <div>
        <Label className="text-xs font-semibold text-[#0F2D5C]">{label}</Label>
        <div
          className="mt-1 rounded-sm border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-700"
          data-testid="user-role-readonly"
        >
          <span className="font-semibold text-[#0F2D5C]">
            {getWorkspaceRoleLabel(targetUser.role, targetUser)}
          </span>
          {targetUser.is_admin_owner ? (
            <p className="mt-1 text-[10px] text-slate-500 m-0">
              Cuenta titular BNT — el rol no se modifica desde esta pantalla.
            </p>
          ) : targetUser.is_buyer_tenant ? (
            <p className="mt-1 text-[10px] text-slate-500 m-0">
              Administrador del comprador — gestione el acceso portal en el catálogo.
            </p>
          ) : null}
        </div>
      </div>
    );
  }

  const options = getAssignableWorkspaceRoleOptions({
    showReseller,
    includeConsulta,
    targetRole: targetUser?.role || value,
  });
  const selectValue = normalizeEditableRole(value, options);

  return (
    <div>
      <Label htmlFor={id} className="text-xs font-semibold text-[#0F2D5C]">
        {label}
      </Label>
      <Select value={selectValue} onValueChange={onChange}>
        <SelectTrigger
          id={id}
          className="mt-1 rounded-sm h-9 text-xs border-amber-200 bg-amber-50/30"
          data-testid="user-role-select"
        >
          <SelectValue placeholder="Seleccione un rol" />
        </SelectTrigger>
        <SelectContent>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectValue === "admin" ? (
        <p className="mt-1 text-[10px] text-slate-500 m-0">
          Mismo nivel operativo que «Administrador de equipo»: empresas, auxiliares y operación diaria. No es titular ni licencia BNT.
        </p>
      ) : null}
    </div>
  );
}
